import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';
import { ActivatedRoute } from '@angular/router';
import { getSummarySectionLinkText } from '../../../helpers/summary-page.helper';

@Component({
    selector: 'motors-summary-page-classified-listing-details-section',
    templateUrl: './summary-page-classified-listing-details-section.component.html',
    styleUrls: ['./summary-page-classified-listing-details-section.component.scss'],
    standalone: false
})
export class SummaryPageClassifiedListingDetailsSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    private _destroyed$: Subject<void> = new Subject<void>();

    askingPrice: string;
    duration: string;
    packageOption: string;
    summarySectionLinkText: string;

    constructor(
        draftFacade: MotorsDraftFacade,
        private _datePipe: DatePipe,
        private route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            const orNearOffer = this.draftData.listingDetails.orNearOffer ? ', or near offer' : '';
            const timeString = this.metadata.auctionTimes.find((f) =>
                f.value === this.draftData.listingDetails.endTime).display.toLocaleUpperCase();
            const dateString = this._datePipe.transform(this.draftData.listingDetails.endDate, 'dd/MM/yyyy');

            this.askingPrice = `$${this.draftData.listingDetails.askingPrice.toLocaleString('en-nz', {minimumFractionDigits: 2})}${orNearOffer}`;
            this.packageOption = this.metadata.fees.find((f) => f.id === this.draftData.listingDetails.categoryPackageId).name;
            this.duration = `Closes ${timeString}, ${dateString}`;
            this.summarySectionLinkText = getSummarySectionLinkText(this.route);

            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
